import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { TransferActionAdapter } from './dto/transfer-action.adapter';
import { TransferActionController } from './transfer-action.controller';
import { TransferAction } from './transfer-action.entity';
import { TransferActionService } from './transfer-action.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([TransferAction]),
  ],
  controllers: [TransferActionController],
  providers: [TransferActionService,TransferActionAdapter,ApplicationExceptionHandler],
  exports:[TransferActionService]
})
export class TransferActionModule {}
